module.exports = __webpack_public_path__ + "img/icon-icon-icn-plus.b5dfc12b.svg";